<template>
    <div>
        <div
            ref="policyCard"
            :class="[isScrollOverCard ?'stickyTop' :'mt-1']"
        >
            <div class="rounded overflow-hidden mb-2.5">
                <div class="md:hidden bg-gray-800 h6 text-white py-[0.3125rem] pl-2.5">
                    {{ policyItem.fullPolicyNo||'— —' }}
                </div>
                <div
                    class="bg-gray-700 h6 text-white flex justify-center justify-items-stretch divide-x divide-gray-400 py-[0.3125rem]"
                    :class="policyInvestment==='Y' ? 'grid grid-cols-3 md:grid-cols-4':'grid grid-cols-2 md:grid-cols-3'"
                >
                    <div class="text-center hidden md:block">
                        <div class="text-gray-200 text-xs shrink-0">
                            保單號碼
                        </div>
                        <div>{{ policyItem.fullPolicyNo|| '— —' }}</div>
                    </div>
                    <div class="text-center shrink-0">
                        <div class="text-gray-200 text-xs">
                            被保險人
                        </div>
                        <div class="w-[5.625rem] truncate mx-auto">
                            {{ policyItem.name|| '— —' }}
                        </div>
                    </div>
                    <div class="text-center shrink-0">
                        <div class="text-gray-200 text-xs">
                            商品幣別
                        </div>
                        <div>
                            {{ policyItem.currencyText|| '— —' }}
                        </div>
                    </div>
                    <div
                        v-if="policyInvestment==='Y'"
                        class="text-center shrink-0"
                    >
                        <div class="text-gray-200 text-xs">
                            投資屬性
                        </div>
                        <div>
                            {{ policyItem.investTypeText|| '— —' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div ref="contentPusher" />
    </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { useEventListener } from '@vueuse/core';
import { useStore } from 'vuex';
import { EUDC } from '@/utils/EUDC';

export default {
    name: 'StickyTopPolicyCard',
    setup() {
        const store = useStore();
        const policyCard = ref(null);
        const contentPusher = ref(null);
        const isScrollOverCard = ref(false);
        const windowWidth = ref(window.innerWidth);

        EUDC();

        const policyItem = computed(() => store.state.policy.policy);
        const policyInvestment = computed(() => store.state.policy.policyKindInvestment);
        const policyCardOffsetTop = ref(null);
        onMounted(() => {
            policyCardOffsetTop.value = policyCard.value.offsetTop;
        });
        useEventListener(window, 'resize', (evt) => {
            windowWidth.value = window.innerWidth;
            if (!isScrollOverCard.value) {
                policyCardOffsetTop.value = policyCard.value.offsetTop;
            }
            if (windowWidth.value > 780) {
                isScrollOverCard.value = false;
                contentPusher.value.style.height = null;
            }
        });
        useEventListener(window, 'scroll', (evt) => {
            if (windowWidth.value < 780) {
                const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
                if (scrollTop > policyCardOffsetTop.value) {
                    const policyCardHeight = policyCard.value.clientHeight;
                    isScrollOverCard.value = true;
                    contentPusher.value.style.height = policyCardHeight + 'px';
                } else {
                    isScrollOverCard.value = false;
                    contentPusher.value.style.height = null;
                }
            }
        });
        return {
            policyCard,
            contentPusher,
            isScrollOverCard,
            policyItem,
            policyInvestment,
        };
    }
};
</script>

<style  lang="scss" scoped>
.stickyTop {
    @apply fixed top-0 left-0 right-0 bg-white z-[51] shadow-1 pt-2.5 px-3 xs:px-5;
}

.pageFade-enter-active,
.pageFade-leave-active {
    transition: opacity 0.4s ease;
}

.pageFade-enter-from,
.pageFade-leave-to {
    opacity: 0;
}
.tabs :deep(.tab) {
    @apply bg-gray-75 p-0 py-1 rounded-t-lg flex-shrink-0 text-[1.3125rem] md:px-4 lg:px-7 text-gray-200 cursor-default;
    height: fit-content;

    &:not(.active) div {
        @apply w-16 truncate;
    }
    &.active {
        @apply bg-white border-b-0 md:px-5 lg:px-7 pb-1 pt-3.5 rounded-t-lg text-[1.3125rem]  text-gray-900 font-bold cursor-default;
    }
}
</style>
